var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhyChooseFiveIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 49,
    viewBox: "0 0 38 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.168 48H28.0046",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09508 33.5077C5.97469 31.8513 4.25723 29.7359 3.07172 27.3205C1.8862 24.905 1.26346 22.2524 1.25027 19.5617C1.19676 9.89425 8.99138 1.8477 18.6566 1.62474C22.4023 1.53401 26.0815 2.62515 29.1721 4.74334C32.2627 6.86153 34.6078 9.8992 35.8747 13.4253C37.1415 16.9515 37.2658 20.7871 36.2298 24.3878C35.1939 27.9886 33.0503 31.1716 30.1033 33.4854C29.4533 33.9894 28.9265 34.6348 28.563 35.3727C28.1995 36.1105 28.0087 36.9214 28.0052 37.7439V39.0817C28.0052 39.5547 27.8173 40.0084 27.4828 40.3429C27.1483 40.6774 26.6946 40.8653 26.2216 40.8653H11.9523C11.4792 40.8653 11.0255 40.6774 10.691 40.3429C10.3565 40.0084 10.1686 39.5547 10.1686 39.0817V37.7439C10.1677 36.9267 9.98055 36.1203 9.62125 35.3863C9.26194 34.6522 8.73999 34.0098 8.09508 33.5077Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8701 8.7594C25.3293 9.51077 29.0326 13.2186 29.7884 17.6777",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyChooseFiveIcon1);
export default __webpack_public_path__ + "static/media/why-choose-five-icon-1.126879633385389d80d19cabafff7c7d.svg";
export { ForwardRef as ReactComponent };